import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import { styled } from '@mui/material';

export const StyledWarningIcon = styled(WarningAmberOutlinedIcon)(
  ({ theme }) => `
  color:${theme.palette.brand?.yellow};
`,
);
